<script context="module">
    export function sortByLabel(a, b) {
      if (a.label == "GsID" || a.label == "LINKID")
        return 1
      else if (b.label == "GsID" || b.label == "LINKID")
        return -1
		  return a.label.localeCompare(b.label)
    }

    export function sortByName(a, b) {
		  return a.name.localeCompare(b.name)
    }

    export function sortById(a, b) {
		  return a.id.localeCompare(b.id)
    }

    export function ignoreCaseSort(a, b) {
		  return a.toLowerCase().localeCompare(b.toLowerCase());
    }

    export function projectSort(a, b) {
      if (a.id == "global")
              return -1
          else if (b.id == "global")
        return 1
      else
        return a.name.localeCompare(b.name)
    }

    export function groupSort(a, b) {
      if (a == "__default__")
              return -1
          else if (b == "__default__")
        return 1
      else
        return a.toLowerCase().localeCompare(b.toLowerCase());
    }
</script>